
// export const crumbsArr = (state) => {
//     return state.crumbsArr;
// }

const getters = {
    cardNumShow: (state) => {
        if((state.roleId == 5 || state.roleId == 6 || state.roleId == 8) && state.customerType == 'DICI_20220207105042004'){
            return false;
        }else{
            return true;
        }
    },
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js